"use strict";

var _taggedTemplateLiteral = require("/usr/local/src/bitcoincom-notary/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

require("core-js/modules/es6.object.define-property");

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: 14px;\n  line-height: 14px;\n  font-weight: 500;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n      ", "\n      text-align: right;\n      & > :last-child {\n        margin-right: ", "px;\n      }\n    "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n        ", "\n        & > :last-child {\n          margin-left: ", "px;\n        }\n      "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n        ", "\n        & > :last-child {\n          margin-bottom: ", "px;\n        }\n      "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n        ", "\n        flex-direction: column;\n        align-items: flex-start;\n      "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  position: relative;\n  cursor: pointer;\n  user-select: none;\n  font-weight: 600;\n  display: flex;\n  width: 100%;\n  justify-content: space-between;\n  color: ", ";\n  padding: ", "px 0;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_components_1 = __importStar(require("styled-components"));

var bitcoincom_pkg_theme_1 = require("@bitcoin-portal/bitcoincom-pkg-theme");

var Label_1 = require("./Label");

var defaultStyles = function defaultStyles(_ref) {
  var theme = _ref.theme;
  return styled_components_1.css(_templateObject(), theme.palette.text.secondary, theme.spacing.unit * 2);
};

exports.LabelStyle = styled_components_1["default"].label(_templateObject2(), function (props) {
  var theme = props.theme,
      position = props.position;
  if (position === Label_1.Positions.Bottom || position === Label_1.Positions.Top) return styled_components_1.css(_templateObject3(), defaultStyles(props));
  if (position === Label_1.Positions.Bottom) return styled_components_1.css(_templateObject4(), defaultStyles(props), theme.spacing.unit);
  if (position === Label_1.Positions.Left) return styled_components_1.css(_templateObject5(), defaultStyles(props), theme.spacing.unit * 3);
  return styled_components_1.css(_templateObject6(), defaultStyles(props), theme.spacing.unit * 3);
});
exports.Error = styled_components_1["default"].div(_templateObject7(), bitcoincom_pkg_theme_1.colors.solid.cinnabar);